import { useEffect, useState } from 'react';

import { LogEvent } from '@analytics';
import * as Dialog from '@radix-ui/react-dialog';
import { NewBoxButton, NewIcon, Spacer } from 'design-system';
import { useRouter } from 'next/router';

export const WebToAppModal = ({
  close,
  onTodayNoShowClick,
}: {
  close: () => void;
  onTodayNoShowClick: () => void;
}) => {
  const router = useRouter();

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!isMounted) return;

    LogEvent.활성화.GAEvent('impression_webToApp', {
      type: 'modal',
    });
  }, [router.pathname, isMounted]);

  return (
    <Dialog.Root open>
      <Dialog.Portal
        forceMount
        container={typeof document !== 'undefined' ? document.getElementById('portal') : undefined}
      >
        <Dialog.Overlay className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0  bg-new-black-50 fixed inset-0 z-[900]" />
        <Dialog.Content className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] fixed bottom-[32px] left-[50%] z-[1000] flex w-[calc(100%-32px)] translate-x-[-50%] flex-col items-center rounded-[24px] border bg-white p-16 duration-200">
          <Dialog.Close
            className="flex w-full items-center justify-end"
            onClick={() => {
              LogEvent.활성화.GAEvent('click_webToApp', {
                type: 'modal',
                action: 'close',
              });
              onTodayNoShowClick();
            }}
          >
            <NewIcon icon="x-outlined" size={20} className="fill-new-gray-400" />
          </Dialog.Close>
          <div className="flex w-full flex-col items-center justify-center">
            <div className="flex flex-col">
              <div className="flex items-center gap-8">
                <div className="bg-new-DTYellow-400 flex items-center justify-center rounded-[8px] p-7">
                  <NewIcon icon="logo-outlined" size={42}></NewIcon>
                </div>
                 
                <NewIcon icon="dt-text-logo" width={87} height={22} className="fill-new-gray-400" />
              </div>
              <Spacer className="h-16" />

              <div className="text-new-Body1-medium text-center">
                운전학원 최저가 예약,
                <br />
                오직 <span className="text-new-Body1-bold">운전선생</span>
                에서!
              </div>
            </div>
            <Spacer className="h-24" />
            <div className="flex w-full flex-col items-center gap-10 px-16">
              <NewBoxButton
                size={'large'}
                className="w-full"
                onClick={() => {
                  LogEvent.활성화.GAEvent('click_webToApp', {
                    type: 'modal',
                    action: 'install-app',
                  });
                  window.open('https://abr.ge/s652mu', '_blank');
                }}
              >
                앱에서 보기
              </NewBoxButton>
              <div
                className="text-new-Body2-medium text-new-gray-500"
                onClick={() => {
                  LogEvent.활성화.GAEvent('click_webToApp', {
                    type: 'modal',
                    action: 'close',
                  });
                  onTodayNoShowClick();
                }}
              >
                오늘은 그냥 볼게요.
              </div>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
